import validateBarcode from 'barcode-validator'

import Yup from '@fourthwall/utils/dist/yup'

import { getDigitalFilesSizeLimitSchema } from '../validators/productValidatorSchema'

export const PRODUCT_SETTINGS_VIEW_TITLE = 'Advanced settings'

export const getValidationSchema = ({
  isTotalDigitalFilesSizeExceeded,
}: {
  isTotalDigitalFilesSizeExceeded: boolean
}) =>
  Yup.object().shape({
    isSoundScanProduct: Yup.boolean(),
    isRequirePhoneNumberFromBuyer: Yup.boolean(),
    format: Yup.string(),
    soundScanCode: Yup.string().when('isSoundScanProduct', {
      is: true,
      then: Yup.string()
        .required()
        .test('validateBarcode', 'This field is not valid EAN/UPC code.', validateBarcode),
    }),
    digitalItems: getDigitalFilesSizeLimitSchema(isTotalDigitalFilesSizeExceeded),
  })
